/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Validators} from '@angular/forms';
import {BundlingSettingsInputEnum} from '../models/bundling-settings-input.enum';
import {
    InputToggleTextConfiguration
} from '../../shared/components/bundling-settings-inputs/input-toggle-text/configuration/input-toggle-text.configuration';
import {InputToggleDropdownConfiguration} from '../../shared/components/bundling-settings-inputs/input-toggle-dropdown/configuration/input-toggle-dropdown.configuration';

export const bundlingSettingsConfiguration: {
    partsBundlingSwitch: InputToggleTextConfiguration;
    periodicityConfiguration: InputToggleDropdownConfiguration;
    periodDaysOffsetConfiguration: InputToggleTextConfiguration;
    periodMaxBundlesConfiguration: InputToggleTextConfiguration;
    bundleMaxValueConfiguration: InputToggleTextConfiguration;
    bundleAggregationConfiguration: InputToggleDropdownConfiguration;
    lineAggregationConfiguration: InputToggleDropdownConfiguration;
    maxBundleLinesConfiguration: InputToggleTextConfiguration;
    bundleCriteriaSection: string;
    bundleAggregationSection: string;
    lineAggregationSection: string;
} = {
    partsBundlingSwitch: {
        code: BundlingSettingsInputEnum.PARTS_BUNDLING,
        toggleButtonConfiguration: {
            label: 'Bundling enabled',
            labelOnRight: true,
            spaceInBetween: 2
        }
    },
    periodicityConfiguration: {
        code: BundlingSettingsInputEnum.PERIODICITY,
        toggleButtonConfiguration: {
            label: 'Periodicity',
            labelOnRight: true,
            spaceInBetween: 2
        },
        placeholder: 'Periodicity',
        hideSwitch: true
    },
    periodDaysOffsetConfiguration: {
        code: BundlingSettingsInputEnum.PERIOD_DAYS_OFFSET,
        toggleButtonConfiguration: {
            label: 'End of the month offset',
            labelOnRight: true,
            spaceInBetween: 2,
        },
        validator: [Validators.maxLength(2), Validators.pattern(/^([1-9]|1[0-5])$/)],
        placeholder: 'Insert offset days (e.g. 1-15)',
        errorMessage: '1-15',
        maxLength: 2
    },
    periodMaxBundlesConfiguration: {
        code: BundlingSettingsInputEnum.PERIOD_MAX_BUNDLES,
        toggleButtonConfiguration: {
            label: 'Max bundles by period',
            labelOnRight: true,
            spaceInBetween: 2,
        },
        validator: [Validators.maxLength(3), Validators.pattern(/^([1-9][0-9]{0,2})$/)],
        placeholder: 'Insert max (e.g. 1-999)',
        errorMessage: '1-999',
        maxLength: 3
    },
    bundleMaxValueConfiguration: {
        code: BundlingSettingsInputEnum.BUNDLE_MAX_VALUE,
        toggleButtonConfiguration: {
            label: 'Max Amount by bundle',
            labelOnRight: true,
            spaceInBetween: 2,
        },
        validator: [Validators.maxLength(10), Validators.pattern(/^([1-9][0-9]{0,9})$/)],
        placeholder: '0¥',
        errorMessage: '1-9999999999',
        addCurrency: true,
        maxLength: 10
    },
    bundleAggregationConfiguration: {
        code: BundlingSettingsInputEnum.BUNDLE_AGGREGATION,
        toggleButtonConfiguration: {
            label: 'Bundle aggregation by',
            labelOnRight: true,
            spaceInBetween: 2,
            minWidth: 126
        },
        placeholder: 'Bundle aggregation',
        hideSwitch: false,
    },
    lineAggregationConfiguration: {
        code: BundlingSettingsInputEnum.LINE_AGGREGATION,
        toggleButtonConfiguration: {
            label: 'Line aggregation by',
            labelOnRight: true,
            spaceInBetween: 2,
            minWidth: 112
        },
        placeholder: 'Line aggregation',
        hideSwitch: false
    },
    maxBundleLinesConfiguration: {
        code: BundlingSettingsInputEnum.MAX_BUNDLE_LINES,
        placeholder: 'Insert max line (e.g. 1-999)',
        errorMessage: '1-999',
        validator: [Validators.maxLength(3), Validators.pattern(/^([1-9][0-9]{0,9})$/)],
        hideToggle: true,
        toggleButtonConfiguration: {
            label: 'Max bundle lines',
            labelOnRight: true,
            spaceInBetween: 2
        },
        maxLength: 3
    },
    bundleCriteriaSection: 'Bundle criteria',
    bundleAggregationSection: 'Bundle aggregation',
    lineAggregationSection: 'Line aggregation'
};
